<template>
  <div class="useCarDetail">
    <div class="useCarHeader">
      <div class="headerTitle">
        <div class="line"></div>
        <div>用车明细</div>
      </div>
    </div>
    <div class="searchDetail">
      <div>
        <el-form style="display: flex; flex-wrap: wrap" :inline="true" :model="detailForm" class="demo-form-inline">
          <el-form-item>
            <el-select v-model="detailForm.zoneId" placeholder="请选择" class="selectWeek" @change="changeCity" clearable>
              <el-option v-for="item in optionCity" :key="item.id" :label="item.zoneName"  :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="isDisabled">
            <el-select style="width: 4rem" v-model="detailForm.applyDeptName" placeholder="请选择" filterable clearable
              @change="searchDetail1(detailAndBranch)">
              <el-option v-for="item in deptList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-date-picker v-model="detailForm.dateTime" type="month" value-format="yyyy-MM" style="width: 3rem"
              :clearable="isClearable" @change="searchDetail1(detailAndBranch)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="searchItems">
              <el-input v-model="detailForm.keywords" placeholder="请输入车牌号或用车人姓名、司机姓名" clearable></el-input>
              <el-button @click="searchDetail1(detailAndBranch)"><van-icon name="search" /></el-button>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportDetail">导出</el-button>
          </el-form-item>
          <el-form-item>
            <div class="radioGroup">
              <el-radio-group v-model="detailAndBranch">
                <el-radio-button :label="1">按明细</el-radio-button>
                <el-radio-button :label="2">按部门</el-radio-button>
              </el-radio-group>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="detailAndBranch === 1">
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#F7F9FA' }"
        v-loading="loading" :max-height="windowHeight">
        <el-table-column prop="useCost" sortable align="center" label="成本中心号" min-width="120" />
        <el-table-column prop="zoonName"  align="center" label="地区" min-width="120" />

        <el-table-column prop="useName" sortable align="center" label="用车人" min-width="120" />
        <el-table-column prop="applyDeptName" sortable align="center" label="用车部门" min-width="120" />
        <el-table-column prop="useCarTime" sortable align="center" label="用车日期" min-width="120" />
        <el-table-column prop="useDuration" sortable align="center" label="用车时长" min-width="120">
        </el-table-column>
        <el-table-column prop="reason" sortable align="center" label="用车事由" min-width="120">
        </el-table-column>
        <el-table-column prop="destination" sortable align="center" label="目的地" show-overflow-tooltip min-width="260" />
        <el-table-column prop="driverName" sortable align="center" label="司机" min-width="120" />
        <el-table-column prop="carBrand" sortable align="center" label="车号" min-width="120" />
        <!-- 只展示 -->
        <el-table-column align="center" sortable label="长途" min-width="120" />
        <el-table-column prop="startMileage" sortable align="center" label="起始里程" min-width="120" />
        <el-table-column prop="endMileage" sortable align="center" label="终点里程" min-width="120" />
        <el-table-column prop="realityMileage" sortable align="center" label="用车里程" min-width="120" />
        <el-table-column prop="travelCost" sortable align="center" label="里程金额" min-width="120" />
        <el-table-column prop="roadBridgeCost" sortable align="center" label="路桥费" min-width="120" />
        <el-table-column prop="otherCost" sortable align="center" label="其他费用" min-width="120" />
        <el-table-column prop="totalCost" sortable align="center" label="用车部门费用" min-width="120" />
        <el-table-column prop="remarks" align="center" label="备注" min-width="120" show-overflow-tooltip />
      </el-table>
    </div>
    <div v-if="detailAndBranch !== 1" class="departmentContainer">
      <div class="tableTitle">2022年{{ dateTime }}月份派车费结算汇总表</div>
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#F7F9FA' }"
        v-loading="deptLoading" :max-height="windowHeight">
        <el-table-column type="index" align="center" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="useCost" align="center" label="成本中心" show-overflow-tooltip min-width="120" />
        <el-table-column prop="zoonName"  align="center" label="地区" min-width="120" />
        <el-table-column prop="applyDeptName" align="center" label="部门" min-width="180" />
        <el-table-column prop="totalCost" align="center" label="金额（元）" min-width="120" />
        <el-table-column prop="remarks" align="center" label="备注" min-width="260" show-overflow-tooltip />
        <!-- 只展示 -->
        <el-table-column align="center" label="审批" min-width="120" />
        <div slot="append">
          <div style="height: 36px;line-height: 36px; margin-left:32px;">
            <span style="margin-right: 81px;  font-weight: bold;">合计：</span>
            <span style="margin-right: 145px;color: #4EA27C;">{{ totalCost }}</span>
            <!-- <span style="margin-right: 30px; font-weight: bold;color: #4EA27C;">转2010100004行政厂务部费用：</span> -->
          </div>
        </div>
      </el-table>
      <div class="row"></div>
    </div>
    <div class="pageContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageData.page"
        :page-sizes="[10, 20, 50, 80, 100]" :page-size="pageData.pageSize" layout="total, prev, pager, next,sizes"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import apiCar from "@/apis/car";
import apis from "@/apis/car";
import moment from "moment";
export default {
  name: "useCarDetail",
  data() {
    return {
      detailForm: {
        applyDeptName: "",
        dateTime: moment(new Date()).format("YYYY-MM"),
        keywords: ""
      },
      deptList: [],
      detailAndBranch: 1,
      tableData: [],
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      loading: false,
      deptLoading: false,
      dateTime: moment(new Date()).format("MM"),
      totalCost: null,
      isClearable: true,
      dirverInfo: {},
      isDisabled: true,
      windowHeight: '',
      optionCity:[]
    };
  },

  mounted() {
    // 监听窗口大小变化，并计算表格高度
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    if (localStorage.getItem('userCode')) {
      this.userCode = localStorage.getItem('userCode');
    }
    this.userCode ? this.isDisabled = false : this.isDisabled = true;
    this.searchDetail1(this.detailAndBranch);
    this.getDeptList();
    this.getCity();
  },
  // 销毁组件时，移除事件监听器
  beforeDestroy() {
    localStorage.removeItem('userCode');
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    changeCity(){
      this.searchDetail1(this.detailAndBranch);
    },
      //获取区域
    getCity() {
      apiCar
        .queryCarZoneByPageList({
          pageSize: "999",
          page: 1,
        })
        .then((res) => {
          console.log(res.data,111111111111111);
          
          if (res.code == 200) {
            const zones = res.data;
            if(!zones){
              return this.$message({
                type: 'warning', // success error warning
                message: '暂无区域权限',
                duration: 2000,
              })
            }
            this.optionCity = zones
            this.detailForm.zoneId = this.optionCity[0].id;
            this.searchDetail1(this.detailAndBranch);

          }
        });
    },
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.windowHeight = window.innerHeight - 175;
    },
    //获取用车明细列表
    searchDetail1(type) {
      if (!this.detailForm.dateTime && this.detailAndBranch == 2) {
        this.detailForm.dateTime = moment(new Date()).format("YYYY-MM");
      }
      this.pageData = {
        page: 1,
        pageSize: 20
      };
      const json = {
        type,
        ...this.detailForm,
        ...this.pageData,
        createUser: this.userCode,
      };
      console.log('this.pageData1', this.pageData);
      if (this.userCode) {
        delete json.applyDeptName;
      }
      this.loading = true;
      this.deptLoading = true;
      apis.queryUseCarList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.loading = false;
          this.deptLoading = false;
          this.deptDate(this.detailForm.dateTime);

          if (this.detailAndBranch === 2) {
            this.totalCost = this.tableData.reduce((prve, item) => {
              return prve + (item.totalCost) * 100;
            }, 0) / 100;
          }

        }
      }).catch(() => {
        this.loading = false;
        this.deptLoading = false;
      });
    },
    //搜索
    searchDetail(type) {
      if (!this.detailForm.dateTime && this.detailAndBranch == 2) {
        this.detailForm.dateTime = moment(new Date()).format("YYYY-MM");
      }
      const json = {
        type,
        ...this.detailForm,
        ...this.pageData,
        createUser: this.userCode,
      };
      if (this.userCode) {
        delete json.applyDeptName;
      }
      console.log('this.pageData2', this.pageData);
      this.loading = true;
      this.deptLoading = true;
      apis.queryUseCarList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.loading = false;
          this.deptLoading = false;
          this.deptDate(this.detailForm.dateTime);

          if (this.detailAndBranch === 2) {
            this.totalCost = this.tableData.reduce((prve, item) => {
              return prve + (item.totalCost) * 100;
            }, 0) / 100;
          }

        }
      }).catch(() => {
        this.loading = false;
        this.deptLoading = false;
      });
    },
    //部门列表
    getDeptList() {
      apis.queryDeptListInfo().then(res => {
        if (res.code === 200) {
          this.deptList = res.data;
        }
      });
    },

    //导出
    exportDetail() {
      const json = {
        ...this.detailForm,
        ...this.pageData,
        type: this.detailAndBranch
      };
      apis.exportExcelInfo(json).then(res => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `用车明细.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.searchDetail(this.detailAndBranch);
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.searchDetail(this.detailAndBranch);
    },
    //格式化时间
    dateFormat(row, column, cellValue) {
      console.log(row, column, cellValue);
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    //格式化时间
    deptDate(newVal) {
      this.dateTime = moment(newVal).format("MM");
    }
  },

  watch: {
    //监听 按明细和按部门的切换
    detailAndBranch(val) {
      this.pageData.page = 1;
      this.pageData.pageSize = 20;
      val == 1 ? this.isClearable = true : this.isClearable = false;
      this.userCode ? this.isDisabled = false : this.isDisabled = true;
      this.searchDetail(val);
    }

  }
};
</script>

<style lang="scss" scoped>
.useCarDetail {
  padding: 30px;

  .useCarHeader {
    display: flex;
    justify-content: space-between;

    .headerTitle {
      font-size: 29px;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;

      .line {
        width: 8px;
        height: 29px;
        background-color: #008755;
        margin-right: 12px;
      }
    }
  }

  .searchDetail {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 15px 0;

    .searchItems {
      display: flex;

      ::v-deep .el-input__inner {
        width: 6rem;
        border-radius: 6px 0 0 6px;
      }

      ::v-deep .el-input__inner:focus {
        border-color: #4ea27c;
      }

      ::v-deep .el-button--mini {
        border: 0;
        background-color: #4ea27c;
        border-radius: 0;
        color: #fff;
      }
    }

    .radioGroup {
      ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: #4ea27c;
        border-color: #4ea27c;
        box-shadow: -1px 0 0 0 #4ea27c;
      }

      // ::v-deep .el-radio-button__inner:hover {
      //   color: none;
      // }
    }
  }

  .departmentContainer {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableTitle {
      font-size: 38px;
      font-weight: 600;
    }
  }

  ::v-deep .el-button--mini {
    border: 0;
    background-color: #4ea27c;
    color: #fff;
  }
}

.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 20px;
}
</style>
